<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.4688 6.4L18.5136 4.3552L19.6448 5.4864L17.6 7.5312V16H20V17.6H17.6V20H16V8H9.6V6.4H16.4688ZM14.4 16V17.6H7.2C6.98783 17.6 6.78434 17.5157 6.63431 17.3657C6.48429 17.2157 6.4 17.0122 6.4 16.8V8H4V6.4H6.4V4H8V16H14.4ZM9.6 9.6H14.4V14.4H9.6V9.6Z"/>
</svg>
